import { z } from 'zod';
import { isoDateSchema } from './shared/iso-date-schema';
import { numericSchema } from './shared/numeric-schema';

// ─── Enums & Constants ────────────────────────────────────────────────────────

export const currencySchema = z.enum(['GCS', 'ICS']);
export const Currency = currencySchema.enum;
export type Currency = z.infer<typeof currencySchema>;

export const transactionStatusSchema = z.enum(['completed', 'inProgress', 'blocked']);
export const TransactionStatus = transactionStatusSchema.enum;
export type TransactionStatus = z.infer<typeof transactionStatusSchema>;

// ─── Entity Schema ────────────────────────────────────────────────────────────

export const transactionSchema = z.object({
  id: z.string(),
  user: z.string(),
  amount: numericSchema.transform(v => v ?? 0),
  currency: currencySchema,
  date: isoDateSchema,
  status: transactionStatusSchema,
});

export type Transaction = z.infer<typeof transactionSchema>;

// ─── API Response Schemas ─────────────────────────────────────────────────────

export const transactionsResponseSchema = z.object({
  transactions: z.array(transactionSchema),
});

export const transactionResponseSchema = z.union([
  z.object({ transaction: transactionSchema }),
  transactionSchema,
]);

export type TransactionsResponse = z.infer<typeof transactionsResponseSchema>;
export type TransactionResponse = z.infer<typeof transactionResponseSchema>;
